/* eslint id-length: [2, {"exceptions":["a","b"]}] */
import template from './refineDataviews.html';
import stateGo from 'redux-ui-router/lib/state-go';

export default function() {
  return {
    scope: {
      dataviews: '=',
    },
    templateUrl: template,
    controller: Controller,
    controllerAs: 'vm',
    bindToController: true,
  };
}

Controller.$inject = ['$scope', '$ngRedux'];
function Controller($scope, $ngRedux) {
  const disconnect = $ngRedux.connect((state) => {
    return {
      activeTab: state.router.currentParams.activeTab,
      dataView: state.router.currentParams.dataView || 0,
    };
  })(this);

  $scope.$on('$destroy', disconnect);

  this.updateDataview = function(selected) {
    // dispatch action to update data type
    $ngRedux.dispatch(stateGo('datacenter.main', {
      dataView: selected,
    }));
  };
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/directives/refineDataviews/refineDataviews.js